<div class="modal-header bg-dark text-white">
  <h3 class="modal-title" id="modal-basic-title">{{isNewContract() ? 'Add Location' : 'Edit Location'}}</h3>
  <div class="ms-auto" data-bs-theme="dark">
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="close()"></button>
  </div>
</div>

<div class="modal-body px-0">

  <!-- Loading indicator while form is being prepared -->
  <div *ngIf="!isFormReady" class="modal-body text-center py-4">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <p class="mt-2 text-muted">Loading form...</p>
  </div>

  <!-- Form content - only show when ready -->
  <form *ngIf="isFormReady" [formGroup]="form" novalidate>
    <!-- Templates for Popovers -->
    <ng-template #popRatioTitle>Award Quota (%)</ng-template>
    <ng-template #popRatioContent>
      <p class="mb-0">What percentage of the {{tender.company.settings.getFieldName('total_volume', 'Yearly Volume')}}
        will be awarded to one supplier?</p>
    </ng-template>
    <ng-template #popAverageUplifeTitle>Average Uplift</ng-template>
    <ng-template #popAverageUplifeContent>
      <p class="mb-0">Input the average amount of fuel that is uplifted per flight at this locaiton. This parameter will
        be used to factor in any per usage based fees during the bid evaluation process.</p>
    </ng-template>

    <ul class="list-group list-group-flush">
      <li class="list-group-item">
        <div class="row">
          <ng-container *ngFor="let field of fields">
            <div [class]="'form-group mb-3 ' + (field.colClass || 'col-12 col-md-4')" [ngSwitch]="field.type">

              <!-- Label -->
              <label
                *ngIf="field.type !== 'fuel_type' && field.type !== 'service_level' && field.type !== 'index' && field.type !== 'delivery_point' && field.type !== 'checkbox'">
                {{field.label}} {{field.required ? '*' : ''}}
                <a *ngIf="field.key === 'award_quota'" href="javascript:void(0)" [ngbPopover]="popRatioContent"
                  [popoverTitle]="popRatioTitle"><i class="fas fa-info-circle ms-1"></i></a>
                <a *ngIf="field.key === 'average_uplift'" href="javascript:void(0)"
                  [ngbPopover]="popAverageUplifeContent" [popoverTitle]="popAverageUplifeTitle"><i
                    class="fas fa-info-circle ms-1"></i></a>
              </label>

              <!-- Controls -->

              <!-- Location Search -->
              <jft-location-search-input *ngSwitchCase="'location_search'" data-testid="contract-location"
                [tender]="tender" [location]="contract.location"
                [control]="form.controls[field.formControlName]"></jft-location-search-input>

              <!-- Text Input -->
              <input *ngSwitchCase="'text'" class="form-control" [formControlName]="field.formControlName"
                [placeholder]="field.placeholder || ''"
                [ngClass]="getFormGroupErrorClasses(form.controls[field.formControlName])">

              <!-- Company specific inputs -->
              <input *ngSwitchCase="'company'" class="form-control" [formControlName]="field.formControlName"
                [placeholder]="field.placeholder || 'Company'"
                [ngClass]="getFormGroupErrorClasses(form.controls[field.formControlName])">

              <!-- Managed Company -->
              <select *ngSwitchCase="'managed_company'" class="form-select" [formControlName]="field.formControlName"
                [ngClass]="getFormGroupErrorClasses(form.controls[field.formControlName])">
                <option [value]="''">Select Company</option>
                <option *ngFor='let item of childCompanies' [ngValue]="item.id">{{ item.getDisplayName() }}</option>
              </select>

              <!-- Number Input -->
              <div *ngSwitchCase="'number'" class="input-group">
                <input [formControlName]="field.formControlName" class="form-control" [mask]="'separator.0'"
                  [leadZero]="true" [thousandSeparator]="','"
                  [ngClass]="getFormGroupErrorClasses(form.controls[field.formControlName])"
                  [placeholder]="field.placeholder || '0'">
                <span *ngIf="field.suffixes || field.key === 'annual_frequency'"
                  class="input-group-text">{{field.suffixes || 'Flights'}}</span>
                <span *ngIf="field.key === 'yearly_volume' || field.key === 'monthly_volume'"
                  class="input-group-text">{{ isHiddenUnits ? tender.units?.code : contract.units?.code }}</span>
              </div>

              <!-- Average Uplift -->
              <div *ngSwitchCase="'average_uplift'" class="input-group">
                <input class="form-control" [formControlName]="field.formControlName" placeholder="">
                <span class="input-group-text">{{contract.units?.code}} per Flight</span>
              </div>

              <!-- Award Quota -->
              <div *ngSwitchCase="'award_quota'" class="input-group">
                <input class="form-control" [formControlName]="field.formControlName"
                  [ngClass]="getFormGroupErrorClasses(form.controls[field.formControlName])" placeholder="Award Quota">
                <span class="input-group-text">%</span>
              </div>

              <!-- Currency Select -->
              <jft-currency-select *ngSwitchCase="'currnecy'"
                [filterFields]="tender.company.settings.getFilterFields('currency')" [allowClear]="false"
                [currencyId]="form.get('currency_id').value"
                (onChange)="form.get('currency_id').patchValue($event); form.markAsDirty()"></jft-currency-select>

              <!-- Units Select -->
              <jft-units-select *ngSwitchCase="'units'" [allowClear]="false"
                [filterFields]="tender.company.settings.getFilterFields('units')"
                (onChange)="form.get('units_id').patchValue($event); form.markAsDirty()"
                [unitId]="form.get('units_id').value"></jft-units-select>

              <!-- Date Picker -->
              <div *ngSwitchCase="'date'" class="input-group">
                <input [ngClass]="getFormGroupErrorClasses(form.controls[field.formControlName])"
                  class="form-control datepicker" [formControlName]="field.formControlName" ngbDatepicker
                  #d="ngbDatepicker">
                <button class="btn btn-outline-secondary" (click)="d.toggle()" type="button"><i
                    class="far fa-calendar-alt"></i></button>
              </div>

              <!-- Textarea -->
              <ng-container *ngSwitchCase="'textarea'">
                <textarea [ngClass]="getFormGroupErrorClasses(form.controls[field.formControlName])"
                  class="form-control" [formControlName]="field.formControlName" [rows]="field.rows || 3"
                  [maxlength]="field.maxlength || 250"></textarea>
                <small class="form-text text-muted" *ngIf="field.maxlength">Maximum {{field.maxlength}}
                  characters</small>
              </ng-container>

              <!-- Delivery Point -->
              <jft-fuel-preference-select *ngSwitchCase="'delivery_point'"
                (onChanges)="form.get('fuel_preference_id').patchValue($event); form.markAsDirty()" [tender]="tender"
                [contract]="contract" [label]="field.label + (field.required ? ' *' : '')"
                [value]="form.get('fuel_preference_id').value"></jft-fuel-preference-select>

              <!-- Fuel Type -->
              <jft-bid-fuel-type *ngSwitchCase="'fuel_type'" [tender]="tender"
                [title]="field.label + (field.required ? ' *' : '')" [itemId]="form.get('fuel_type_id').value"
                (onChanges)="onChangeFuelType($event)"></jft-bid-fuel-type>

              <!-- Service Level -->
              <jft-bid-service-level *ngSwitchCase="'service_level'"
                [title]="field.label + (field.required ? ' *' : '')" [itemId]="$safeNavigationMigration(contract.iataServiceLevel?.id)"
                (onChanges)="onChangeServiceLevel($event)"></jft-bid-service-level>

              <!-- Tags -->
              <div *ngSwitchCase="'tags'">
                <ng-select [items]="locationTags" [addTag]="addLocationTag" multiple="true" bindLabel="name"
                  (ngModelChange)="locationTagChange($event)" [(ngModel)]="selectedLocationTags"
                  [ngModelOptions]="{standalone: true}" placeholder="Select or create location tags">
                  <ng-template ng-tag-tmp let-search="searchTerm"><b>create new</b>: {{ search }} </ng-template>
                </ng-select>
                <small class="form-text text-muted">Select existing tags or type to create new ones</small>
              </div>

              <!-- Checkbox (e.g. Branded) -->
              <ng-container *ngSwitchCase="'checkbox'">
                <label>{{field.label}}</label>
                <div class="input-group">
                  <div class="input-group-text">
                    <input type="checkbox" class="form-check-input mt-0" [formControlName]="field.formControlName"
                      [id]="field.formControlName">
                  </div>
                  <label class="form-control mb-0" [for]="field.formControlName">Branded Location</label>
                </div>
              </ng-container>

              <!-- Select (e.g. Flight Type) -->
              <select *ngSwitchCase="'select'" class="form-select" [formControlName]="field.formControlName"
                [ngClass]="getFormGroupErrorClasses(form.controls[field.formControlName])">
                <option [value]="''" disabled>Select {{field.label}}</option>
                <option *ngFor='let item of field.options' [ngValue]="item.id">{{ item.name }}</option>
              </select>


              <!-- Validation Errors -->
              <div class="invalid-feedback"
                *ngIf="form.controls[field.formControlName] && showErrorBlock(form.controls[field.formControlName])">
                <p
                  *ngIf="form.controls[field.formControlName].errors?.required || form.controls[field.formControlName].errors?.required == ''">
                  {{field.label}} field is required</p>
                <p *ngIf="form.controls[field.formControlName].errors?.serverError">{{
                  form.controls[field.formControlName].errors?.serverError }}</p>
                <p *ngIf="form.controls[field.formControlName].errors?.min">Value must be greater than 0</p>
                <p *ngIf="form.controls[field.formControlName].errors?.integer">Integer value format is required</p>
              </div>
            </div>
          </ng-container>
        </div>
      </li>
    </ul>
  </form>
</div>

<div class="modal-footer">
  <button class="btn btn-link fw-bold text-decoration-none" (click)="close()">Close</button>
  <jft-submit-button *ngIf="isFormReady" data-testid="contract-save" (onClick)="submitContract()"
    [loading]="$safeNavigationMigration(form?.disabled)"
    [class]="'btn btn-primary'" [disabled]="$safeNavigationMigration(form?.invalid)" [ngbPopover]="getFirstFormGroupErrorLabel(form)"
    triggers="mouseenter:mouseleave" placement="left" [title]="!isNewContract() ? 'Update' : 'Save'"
    [loadingTitle]="'Saving'" triggers="mouseenter:mouseleave" placement="right">
  </jft-submit-button>
</div>